import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-close-token',
  templateUrl: './dialog-close-token.component.html',
  styleUrls: ['./dialog-close-token.component.scss'],
  standalone: false
})
export class DialogCloseTokenComponent implements OnInit {

  message: any;

  constructor(public dialogRef: MatDialogRef<DialogCloseTokenComponent>,
              @Inject(MAT_DIALOG_DATA) public defaults: any) {
  }

  ngOnInit() {
  }

}
